import NotFoundPage from '../../components/NotFoundPage';
import { RouteObject } from 'react-router';

export const errorRoutes: RouteObject[] = [
  { path: '404', element: <NotFoundPage /> },
  { path: '*', element: <NotFoundPage /> },
];
